/* eslint-disable complexity */
import React, {useContext} from 'react';
import {forBrands, styled, useTheme, getFontWeight} from '@core-ui/react-stitch';
import {BreakpointContext, LARGE} from '@core-ui/breakpoint-provider';
import useBRRedesign from '../../hooks/features/useBRRedesign';

const getGapHeaderStyles = theme => ({
  ...theme.brandFont,
  color: theme.color.g2,
  fontWeight: 'bold',
});

const getAthletaHeaderStyles = theme => ({
  ...theme.brandFont,
  color: theme.color.gray54,
  fontSize: `2.25rem`,
  letterSpace: 2,
});

const getOldNavyHeaderStyles = theme => ({
  ...theme.brandFont,
  color: theme.color.g2,
  fontSize: '1.5rem',
  fontWeight: 'normal',
  letterSpacing: '0.10em',
});


const getBananaRepublicHeaderStylesNewFonts = (theme, isBRRedesignEnabled) => ({
      ...theme.brandFontAlt,
      fontWeight: isBRRedesignEnabled ? getFontWeight('regular').fontWeight : getFontWeight('light').fontWeight,
      letterSpacing: isBRRedesignEnabled ? '' : '0.15em',
      color: isBRRedesignEnabled ? theme.color.inverse.b1 : theme.color.g1,
      textTransform: isBRRedesignEnabled ? 'capitalize' : '',
});

export const CatPageTitleText = ({children, isBRRedesignEnabled}) => {
  const theme = useTheme();

  const brandStyles = forBrands(theme, {
    gap: getGapHeaderStyles,
    gapfs: getGapHeaderStyles,
    br: getBananaRepublicHeaderStylesNewFonts(theme, isBRRedesignEnabled),
    brfs: getBananaRepublicHeaderStylesNewFonts(theme, isBRRedesignEnabled),
    at: getAthletaHeaderStyles,
    on: getOldNavyHeaderStyles,
  });

  const Header = styled.h1(() => ({
    display: 'inline',
    lineHeight: isBRRedesignEnabled ? '40px' : '1',
    fontSize: isBRRedesignEnabled ? '2.125em' : '1.6875em',
    ...brandStyles,
  }));

  return <Header>{children}</Header>;
};

export const CatPageTitle = ({children}) => {
  const theme = useTheme();
  const {greaterOrEqualTo} = useContext(BreakpointContext);
  const greaterOrEqualToLarge = greaterOrEqualTo(LARGE);

  const catPageTitleStyle = {
    textAlign: 'center',
    textTransform: 'uppercase',
    padding: greaterOrEqualToLarge ? '2rem 0 0' : '1rem 0',
    ...forBrands(theme, {
      at: () => ({
        margin: 0,
        maxWidth: '100%',
        ...greaterOrEqualToLarge ? {background: 'none'} : {},
      }),
    }),
  };

  return (
    <div className="limit-width clearfix" css={catPageTitleStyle}>
      {children}
    </div>
  );
};

const emptyRenderUseCases = [{
  compareFn: (shouldHideTitle, position, categoryName) => { return shouldHideTitle; },
},{
  compareFn: (shouldHideTitle, position, categoryName) => { return ['topPrimary', 'bottom'].indexOf(position) >= 0; },
},{
  compareFn: (shouldHideTitle, position, categoryName) => { return categoryName === ''; },
}];

export const FallbackHeader = ({
  position,
  shouldHideTitle,
  bannerName,
}) => {
  const shouldNotRender = emptyRenderUseCases
    .filter(o => o.compareFn(shouldHideTitle, position, bannerName))
    .reduce(() => true, false);

  const isBRRedesignEnabled = useBRRedesign();

  return shouldNotRender
    ? null
    : (
    <CatPageTitle>
      <CatPageTitleText isBRRedesignEnabled={isBRRedesignEnabled}>
        {bannerName}
      </CatPageTitleText>
    </CatPageTitle>
  );
};

export default {FallbackHeader};
